<template>
  <div class="bg-white rounded-2xl p-6 shadow-sm border border-gray-100">
    <div class="flex justify-between items-center mb-6">
      <h3 class="font-bold text-gray-800 text-lg">Attendance Trend</h3>
      <!-- Dropdown or filter could go here -->
      <div class="px-3 py-1 bg-gray-50 border border-gray-200 rounded-md text-xs text-gray-600">
        Last 7 Days
      </div>
    </div>

    <div class="h-64 w-full">
       <BarChart
         v-if="chartData.labels.length"
         :labels="chartData.labels"
         :values="chartData.values"
         color="#3B82F6"
         label="Present Students"
       />
       <div v-else class="h-full flex items-center justify-center text-gray-400 text-sm">
         No attendance data available
       </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import BarChart from './BarChart.vue';
import type { DashboardStats } from '@/types/composition-functions';

// Extract AttendanceTrendDay type
type AttendanceTrendDay = DashboardStats['attendanceTrend'][number];

const props = defineProps<{
  trend: AttendanceTrendDay[]
}>();

const chartData = computed(() => {
  const data = props.trend || [];
  // Sort by date just in case
  const sorted = [...data].sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());

  return {
    labels: sorted.map(t => new Date(t.date).toLocaleDateString('en-US', { weekday: 'short' })),
    values: sorted.map(t => t.present),
  };
});
</script>
